import { create } from 'zustand';
import _cloneDeep from 'lodash/cloneDeep';

interface NprStoreValues {
  nprResult: string;
}

interface NprState extends NprStoreValues {
  setNprResult: (nprResult: string) => void;
  resetNprState: () => void;
}

const defaults: NprStoreValues = {
  nprResult: '',
};

export const useNpr = create<NprState>((set) => ({
  ..._cloneDeep(defaults),
  setNprResult: (nprResult: string) => set({ nprResult }),
  resetNprState: () => set(defaults),
}));
